import { ActionTree } from 'vuex'
import { State } from '.'

const actions: ActionTree<State, any> = {
	setLoginError({ state, commit }, payload: false | string) {
		commit('setLoginError', payload)
	},
	setLoginMessage({ state, commit }, payload: false | string) {
		commit('setLoginMessage', payload)
	},
	setPreventNavigation({ state, commit }, payload: {prevent: boolean, message?: string}) {
		commit('setPreventNavigation', payload)
	}
}

export default actions
